import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { AccountData, totalCompetitions } from './accountData';

const linkClass = ({ isActive }: { isActive: boolean }) => `account-nav__link${isActive ? ' account-nav__link--active' : ''}`;

const AccountNav: React.FC<{ data: AccountData }> = ({ data }) => {
  const { user } = useAuth();
  const fullName = [user?.profile?.firstName, user?.profile?.lastName].filter(Boolean).join(' ');
  const nickname = (user?.nickname || user?.profile?.nickname || '').trim();
  const total = totalCompetitions(data);
  return (
    <nav className="account-nav" aria-label="Account" data-tour="account-nav">
      <div className="account-nav__who">
        <strong>{user?.username}</strong>
        {(fullName || nickname) && <span>{fullName || nickname}</span>}
      </div>
      <NavLink to="/profile" end className={linkClass}>Overview</NavLink>
      <NavLink to="/profile/notifications" className={linkClass}>
        Notifications
        {!!data.unread && (
          <span className="account-nav__badge account-nav__badge--accent">
            {' '}{data.unread}<span className="sr-only"> unread</span>
          </span>
        )}
      </NavLink>
      <NavLink to="/profile/work" className={linkClass}>
        My competitions
        {!!total && (
          <span className="account-nav__badge">
            {' '}{total}<span className="sr-only"> competitions</span>
          </span>
        )}
      </NavLink>
      <NavLink to="/profile/settings" className={linkClass}>Settings</NavLink>
      {user?.role === 'admin' && (
        <>
          <hr className="account-nav__divider" />
          <NavLink to="/admin" className={linkClass}>Admin</NavLink>
        </>
      )}
    </nav>
  );
};

export default AccountNav;
